export default "__VITE_ASSET__2aa6b950__"